.icon {
  background-color: var(--iconColorPrimary);
  display: inline-block;
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: contain;
}
.icon.currentColor {
  background-color: currentColor;
}
.icon.navbar {
  background-color: var(--navBarText);
}
.icon.contextMenu {
  background-color: var(--contextMenuText);
}
.icon.fullscreenControls {
  background-color: var(--fullScreenMediaButtonsText);
}
.icon.appearanceSelector {
  background-color: var(--icon-color);
}
.icon.remove:hover {
  background-color: #bf0000;
}

.iconButton {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  text-align: inherit;
  display: flex;
}